import { FC } from "react";

import { Dialog, SxProps, Theme, ThemeProvider } from "@mui/material";

import { useMediaQuery } from "@/common/hooks/useMediaQuery";
import { zeffyTheme } from "@/common/theme/theme";
import { DashboardDrawer } from "@/dashboard-design-system/Drawer";

type ShareFormModalProps = {
  open: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

export const ShareFormModal: FC<ShareFormModalProps> = ({ open, onClose, children, sx }) => {
  const { isSmallScreen } = useMediaQuery();

  if (isSmallScreen) {
    return (
      <ThemeProvider theme={zeffyTheme}>
        <DashboardDrawer
          onClose={onClose}
          open={open}
          anchor="bottom"
          data-test="share-form-modal"
          slots={{
            header: <></>, // Show the drawer as if it has a header since it's rendered within the content
          }}
          noPadding
          hasStickyHeader
          sx={sx}
        >
          {children}
        </DashboardDrawer>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={zeffyTheme}>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth data-test="share-form-modal" sx={sx}>
        {children}
      </Dialog>
    </ThemeProvider>
  );
};
